import { api, useRoleConf, useSuspenseQuery } from "../../../hooks"
import type { Period } from "../../../types"
import { getPeriodDateRange, stringifyQueryObj } from "../../../utils"
import type { PurchasesChannelName } from "../../referential"
import { financialDataPurchasesRoleConf } from "./financialDataPurchases.apiRoleConf"
import type { ApiPurchasesSummary } from "./financialDataPurchases.model"
import { selectPurchases } from "./financialDataPurchases.select"

// Les params supplémentaires sont passés en query params de la requête
export const useFinancialDataPurchasesApi = ({
  pinnedChannels = [],
  params: { period, pharmacyId, ...params },
}: {
  pinnedChannels?: PurchasesChannelName[]
  params: {
    period: Period
    pharmacyId?: string
  } & Record<string, unknown>
}) => {
  const dateRange = getPeriodDateRange(period)

  const { queryKey, endpoint } = useRoleConf(
    financialDataPurchasesRoleConf(pharmacyId),
  )

  const queryParams = stringifyQueryObj({ ...dateRange, ...params })

  // GET
  const { data: purchasesSummary, isLoading } = useSuspenseQuery({
    queryKey: [...queryKey, period, ...Object.values(params).filter(Boolean)],
    queryFn: () => api.get<ApiPurchasesSummary>(`${endpoint}?${queryParams}`),
    select: (data) => selectPurchases(data, pinnedChannels),
  })

  return { purchasesSummary, isLoading }
}
